const uuidv4 = (): string =>
  'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    const r = Math.random() * 16;
    const v = c === 'x' ? Math.floor(r) : Math.floor(r / 4) + 8;
    return v.toString(16);
  });

export default uuidv4;
